import { Link } from "react-router-dom";
import { format } from "date-fns";
import { Calendar, Clock, Video, Phone, Loader2 } from "lucide-react";

const UpcomingAppointments = ({ appointments = [], loading = false }) => {
  const formatDate = (date) => {
    try {
      const d = new Date(date);
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);

      if (d.toDateString() === today.toDateString()) {
        return "Today";
      } else if (d.toDateString() === tomorrow.toDateString()) {
        return "Tomorrow";
      }
      return format(d, "MMM d");
    } catch {
      return "N/A";
    }
  };

  const formatTime = (time) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":");
    const h = parseInt(hours);
    const ampm = h >= 12 ? "PM" : "AM";
    const hour12 = h % 12 || 12;
    return `${hour12}:${minutes} ${ampm}`;
  };

  const getInitials = (name) => {
    if (!name) return "?";
    return name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <div className="p-3">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-base font-semibold text-gray-900">Upcoming</h2>
        <Link to="/appointments" className="text-xs text-orange-500 hover:text-orange-600">
          View All
        </Link>
      </div>

      {loading ? (
        <div className="flex justify-center items-center py-6">
          <Loader2 className="h-5 w-5 text-orange-500 animate-spin" />
        </div>
      ) : appointments.length === 0 ? (
        <div className="text-center py-6 text-gray-500">
          <Calendar className="h-8 w-8 mx-auto mb-2 text-gray-300" />
          <p className="text-xs">No upcoming appointments</p>
        </div>
      ) : (
        <div className="space-y-2">
          {appointments.slice(0, 4).map((apt) => (
            <div
              key={apt._id}
              className="flex items-center gap-2 p-2 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
            >
              {/* Avatar */}
              {apt.user?.picture ? (
                <img
                  src={apt.user.picture}
                  alt={apt.user.name}
                  className="w-8 h-8 rounded-full object-cover flex-shrink-0"
                />
              ) : (
                <div className="w-8 h-8 rounded-full bg-orange-100 text-orange-600 flex items-center justify-center text-xs font-medium flex-shrink-0">
                  {getInitials(apt.user?.name)}
                </div>
              )}

              {/* Details */}
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900 truncate">
                  {apt.user?.name || "Unknown"}
                </p>
                <div className="flex items-center gap-2 text-xs text-gray-500">
                  <span>{formatDate(apt.date)}</span>
                  <span>·</span>
                  <span>{formatTime(apt.time)}</span>
                </div>
              </div>

              {/* Mode Icon */}
              <div className="flex-shrink-0">
                {apt.mode === "video" ? (
                  <Video className="h-4 w-4 text-gray-400" />
                ) : (
                  <Phone className="h-4 w-4 text-gray-400" />
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UpcomingAppointments;
